import React, { FC } from 'react';
import { Trans } from '@edreamsodigeo/frontend-core';
import { Heading } from '@edreamsodigeo/prisma-design-system';
import { AlternativeItineraryLayerTitleProps } from '../types';
import {
  calculatePriceDifference,
  Highlight,
  PriceDifference,
} from '../AlternativeItineraryDoubleCardDecorators';
import { AlternativeItineraryValuePropositionType } from 'clientState/providers/AlternativeItineraryProvider/types';
import { useFlowTools } from 'flowTools/useFlowTools';

const alternativeItineraryValuePropositionTranslationKey: Record<
  AlternativeItineraryValuePropositionType,
  string
> = {
  price: 'price',
  discount: 'discountAmount',
  cabinLuggage: 'cabinLuggage',
  checkedLuggage: 'checkedLuggage',
  airport: 'airport',
  convenience: 'convenience',
  social: 'social',
  directFlight: 'directFlight',
};

const AlternativeItineraryDoubleCardLayerSectionTitle: FC<
  AlternativeItineraryLayerTitleProps
> = ({
  valueProposition,
  valuePropositions,
  itinerary,
  selectedItinerary,
  nonIssuable,
  discountAmount,
}) => {
  const { isDesktop } = useFlowTools();
  const { priceDifference } = calculatePriceDifference(
    itinerary,
    selectedItinerary
  );

  const valuePropositionTranslationKey =
    alternativeItineraryValuePropositionTranslationKey[valueProposition];

  const contentKey = `alternativeItinerary.${
    nonIssuable ? 'nonIssuable' : 'issuable'
  }.title.${
    valueProposition === 'discount' &&
    discountAmount?.amount === 0 &&
    priceDifference > 0
      ? valuePropositions[valuePropositions.length - 1]
      : valuePropositionTranslationKey
  }`;
  return (
    <Heading
      type={isDesktop ? '2' : '3'}
      weight="medium"
      color="neutral.90"
      sx={{
        paddingBottom: isDesktop ? '0' : 'base',
      }}
      data-testid="alternative-itinerary-card-layer-title"
    >
      <Trans
        i18nKey={contentKey}
        components={{
          highlight: <Highlight isPositive={true} />,
          priceDifference: (
            <PriceDifference
              itinerary={itinerary}
              selectedItinerary={selectedItinerary}
            />
          ),
        }}
      />
    </Heading>
  );
};

export default AlternativeItineraryDoubleCardLayerSectionTitle;
